import { Filter } from './filter';
import { LogicalOperator } from './logical-operator';
// @ts-ignore
import * as uuid from 'uuid';

export class FilterGroup {
    public logicalOperator: string; // ?
    public filters: Array<Filter>;

    public hasSibling: boolean;

    public id: string;

    public constructor(logicalOperator?: string, filters?: Array<Filter>, hasSibling?: boolean) {
        this.id = uuid.v4();

        if (logicalOperator != null) {
            this.logicalOperator = logicalOperator;
        }

        if (filters != null && filters.length > 0) {
            const tempFilters = new Array<Filter>();
            filters.forEach((filter) => {
                const newFilter = new Filter(this.id);
                newFilter.field = filter.field;
                newFilter.foreignKeyValues = filter.foreignKeyValues;
                newFilter.isVariable = filter.isVariable;
                // this needs to be done as server is enum and values come in as an Int,but the operator dropdown's values are text
                if (filter.logicalOperator != null) {
                    switch (filter.logicalOperator.toString()) {
                    case '0':
                        newFilter.logicalOperator = 'And';
                        break;
                    case '1':
                        newFilter.logicalOperator = 'Or';
                        break;
                    }
                }
                if (filter.operator != null) {
                    newFilter.operator = filter.operator.toString();
                }
                newFilter.showValue = filter.showValue;
                newFilter.value = filter.value;
                newFilter.variableName = filter.variableName;
                tempFilters.push(newFilter);
            });
            this.filters = tempFilters;
        } else {
            const tempFilters = new Array<Filter>();
            tempFilters.push(new Filter(this.id));
            this.filters = tempFilters;
        }

        if (hasSibling != null) {
            this.hasSibling = hasSibling;
        }
    }
}
